import {CONFIG} from "../../config";
import axios from "axios";

async function GetInformation(id) {
    const location = CONFIG.API_URL + "telemetry/get/" + id;
    const settings = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('bearer-token')}`,
        }
    };

    try {
        return await axios.get(location, settings);
    } catch (e) {
        return null;
    }
}

export default GetInformation;